import React, {useState} from 'react';
import ChildrensBookManuscriptEditor from './ChildrensBookManuscriptEditor';
import NextScenesBookBlueprintNavigator from './NextScenesBookBlueprintNavigator';
import {sceneFirstDraftV1E5C} from '../utils/childrensBookSceneFirstAuthorV1E5C';

// The existing rich text editor; a Scene ID replaces the old physical page ID.
// Parent Book Workspace alone persists. Never invent a physical page or save to Novel.
export default function ChildrensBookSceneFirstWriterV1E5C({
  lang='en',draft,chapter,scene,readOnly=false,savedAudienceReady=false,onTextChange,onReturn,
}) {
  const fr=String(lang).toLowerCase().startsWith('fr');
  const canWrite=!readOnly && savedAudienceReady;
  const [stage,setStage]=useState('write');
  const entry=sceneFirstDraftV1E5C(draft,scene?.key);
  return <main data-cb-v1e5c-scene-first-writer="true">
    <NextScenesBookBlueprintNavigator
      currentWorkspace={canWrite?stage:'review'}
      projectTitle={String(draft?.identity?.title||'Children’s Book')}
      blueprintLabel={fr?'PARCOURS WRITER STUDIO':'WRITER STUDIO PATH'}
      workspaces={[
        {id:'write',label:fr?'Écrire':'Write',status:canWrite?'in_progress':'waiting',disabled:!canWrite},
        {id:'review',label:fr?'Réviser':'Review',status:'ready'},
      ]}
      onNavigate={next=>{if(next==='review'||(next==='write'&&canWrite))setStage(next);}} readyCount={canWrite?2:1} statusTotal={2}
      isFR={fr} accent="#047857" accentDark="#065f46" accentSoft="#ecfdf5"
      border="rgba(4,120,87,0.24)" background="linear-gradient(180deg,rgba(236,253,245,0.96),#fff)"
    />
    <section className="ns-card ws-current-work-card" style={{padding:18,marginBottom:16}}>
      <div className="ns-card-meta" style={{fontWeight:800}}>{fr?'TRAVAIL EN COURS':'CURRENT WORK'}</div>
      <h2>{chapter?.title || (fr?'Chapitre':'Chapter')} · {scene?.title || (fr?'Scène':'Scene')}</h2>
      <button type="button" className="ns-button ns-button-outline" onClick={onReturn}>
        {fr?'← Retour au livre':'← Back to Book'}
      </button>
      <p className="ns-card-meta">{fr
        ?'Le manuscrit de cette scène est indépendant des pages. Utilisez « Enregistrer les modifications » en haut pour conserver votre travail.'
        :'This Scene manuscript is independent of pages. Use Save Changes above to preserve your work.'}</p>
      {!savedAudienceReady?<p role="note">{fr?'Enregistrez d’abord le public cible dans Book Setup.':'Save the Audience in Book Setup before writing.'}</p>:null}
    </section>
    <ChildrensBookManuscriptEditor
      key={entry.id} lang={lang} entry={entry} disabled={!canWrite||stage==='review'}
      saveActionLabel={fr?'Enregistrer les modifications':'Save Changes'}
      onChange={fields=>{if(canWrite&&stage==='write') onTextChange?.(scene.key,fields.manuscriptContent);}}
    />
  </main>;
}
